import { useState } from "react";
import { useStore, actions } from "../../store";
import { IconButton, IconHelp16 } from "../../ui-kit";
import ContactInfo from "./ContactInfo";

const Header = () => {
  const { state, dispatch } = useStore();
  const [showContactInfo, setShowContactInfo] = useState(false);

  const isPro = state.membership === "PRO";

  const handleOpenUpgrade = () => {
    dispatch(actions.openUpgradeModal("general"));
  };

  const handleOpenContactInfo = () => {
    setShowContactInfo(true);
  };

  const handleCloseContactInfo = () => {
    setShowContactInfo(false);
  };

  const getPlanBadgeColor = () => {
    if (isPro) return {
      bg: "var(--figma-color-bg-brand)",
      text: "white",
      label: state.membership
    };
    return {
      bg: "var(--figma-color-bg-success-tertiary)",
      text: "var(--figma-color-border-success-strong)",
      label: "Get Pro"
    };
  };

  const badgeColors = getPlanBadgeColor();

  return (
    <div className="header">
      <div className="header-left">
        <div className="brand-text">
          <span className="brand-name">html.to</span>
          <span className="brand-domain">make.design</span>
          <span className="brand-llama">llama</span>
        </div>
      </div>

      <div className="header-right">
        <div className="plan-info">
          <div
            className="plan-badge hover:bg-figma-bg-success-tertiary"
            style={{
              backgroundColor: badgeColors.bg,
              
              color: badgeColors.text,
              cursor: isPro ? 'default' : 'pointer',
            }}
            onClick={!isPro ? handleOpenUpgrade : undefined}
          >
            {badgeColors.label} 
          </div>
       
          
          {isPro && (
            <div className="quick-stats">
              <span className="stats-label">Unlimited</span>
            </div>
          )}
          <div className="quick-stats" onClick={handleOpenContactInfo} style={{ cursor: "pointer" }}>
            <IconButton><IconHelp16/></IconButton>
          </div>
        </div>
      </div>

      {/* Contact Info Modal */}
      <ContactInfo open={showContactInfo} onClose={handleCloseContactInfo} />

      <style
        dangerouslySetInnerHTML={{
          __html: `
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: var(--figma-color-bg);
          border-bottom: 1px solid var(--figma-color-border);
          padding: 12px 16px;
          width: 100%;
        }

        .header-left {
          flex-shrink: 0;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-left: auto;
        }

        .brand-text {
          display: flex;
          align-items: baseline;
          gap: 0;
        }

        .brand-name {
          font-size: 14px;
          font-weight: 700;
          color: var(--figma-color-text);
          letter-spacing: -0.01em;
        }

        .brand-domain {
          font-size: 14px;
          font-weight: 400;
          color: var(--figma-color-text-secondary);
          letter-spacing: -0.01em;
        }

        .brand-llama {
          font-size: 10px;
          font-weight: 500;
          color: var(--figma-color-text-tertiary);
          margin-left: 6px;
        }

        .plan-info {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .plan-badge {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          line-height: 1;
          transition: all 0.2s ease;
          user-select: none;
        }

        .plan-badge[style*="cursor: pointer"]:hover {
          opacity: 0.7;
          transform: scale(1.05);
        }

        .plan-badge[style*="cursor: pointer"]:active {
          transform: scale(0.95);
        }

        .quick-stats {
          display: flex;
          align-items: baseline;
          gap: 4px;
        }

        .stats-value {
          font-size: 14px;
          font-weight: 700;
          color: var(--figma-color-text);
        }

        .stats-label {
          font-size: 11px;
          font-weight: 500;
          color: var(--figma-color-text-secondary);
        }
      `,
        }}
      />
    </div>
  );
};

export default Header;
